import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id DF35C024-A010-482D-8B28-D567A1C9389D
 * name credit-card-chip-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/credit-card-chip-outline.svg
 * tags
 * - Banking 
 */
export const CreditCardChipOutlineIcon = createSvgIcon(<><path d="M20 6L20 18L4 18L4 6H20M20 4H4C2.89 4 2 4.89 2 6V18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4M11 10H6V14H11V10Z" /></>, 'CreditCardChipOutlineIcon');
export default CreditCardChipOutlineIcon